import axios from 'axios'

export const downloadExcel = async (opts) => {
  console.log(opts)
  let res = await axios({
    method: opts.method,
    url: opts.url,
    data: opts.data,
    responseType: 'blob'
  })
  console.log(res)
  let resBlob = res.data
  var url = window.URL.createObjectURL(resBlob)
  var a = document.createElement('a');
  a.download = opts.fileName+'.xls'
  a.href = url;
  a.click();
  window.URL.revokeObjectURL(url)

  // try {
  //   let resText = await new Promise((resolve,reject)=>{
  //     let reader = new FileReader()
  //     reader.addEventListener('abort',reject)
  //     reader.addEventListener('error',reject)
  //     reader.addEventListener('loadend',()=>{
  //       console.log(reader.result)
  //       resolve(reader.result)
  //     })
  //     reader.readAsText(resBlob)
  //   })
  // }catch (error){
  //
  // }

  return {res, resBlob}

}
// request拦截器
axios.interceptors.request.use(
  config => {
    // Do something before request is sent

    // console.log(config)
    let token = localStorage.getItem('token')
    if (token) {
      config.headers.common['accessToken'] = token
    }
    return config
  },
  error => {
    // Do something with request error
    // console.log(error) // for debug
  }
)
export const qrcodeDown = async (opts) => {
  console.log(localStorage.getItem('token'))
  let res = await axios({
    method: opts.method,
    url: opts.url,
    data: opts.data,
    responseType: 'arraybuffer',
    headers: {
      "accessToken": localStorage.getItem('token')
   }
  })
  console.log(res)
  let resBlob = res.data
  if (!resBlob) {
    return
  }
  let url = window.URL.createObjectURL(new Blob([resBlob],{type: "application/octet-stream"}));
  let link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.setAttribute('download', opts.fileName);
  document.body.appendChild(link);
  link.click();

  // try {
  //   let resText = await new Promise((resolve,reject)=>{
  //     let reader = new FileReader()
  //     reader.addEventListener('abort',reject)
  //     reader.addEventListener('error',reject)
  //     reader.addEventListener('loadend',()=>{
  //       console.log(reader.result)
  //       resolve(reader.result)
  //     })
  //     reader.readAsText(resBlob)
  //   })
  // }catch (error){
  //
  // }
  return {res, resBlob}
}



// WEBPACK FOOTER //
// ./src/utils/downloadFetch.js